import React from "react";
import Banner from "../components/comman/Banner";
import ProductCard from "../components/home/ProductCard";
const Product = () => {
  return (
    <div>
      <Banner title="Products" />
      <ProductCard />
    </div>
  );
};
export default Product;
